<template>
  <div class="pt-editor">
    <div class="pt-editor-container">
      <pt-modes :state="state" @toggle-editor-mode="toggleEditorMode" />

      <div class="map-editor__controls" v-if="state.history.length">
        <el-button
          class="r-button map-editor__controls-button"
          :loading="state.loading"
          size="mini"
          type="success"
          @click="saveData"
        >
          Сохранить изменения
        </el-button>
      </div>

      <editor-history
        :editor-state="state"
        @change-history-step="changeHistoryStep"
        @clear-editing-state="clearEditingState"
      />
    </div>

    <pt-help :mode="mode" :state="state" />
  </div>
</template>

<script>
import PtModes from "./editor/pt-modes";
import EditorHistory from "@/components/map/components/map-editor/editor-history";
import PtHelp from "./editor/pt-help";

export default {
  props: ["map", "draw", "state", "mode", "controller"],
  components: {
    PtModes,
    EditorHistory,
    PtHelp
  },
  methods: {
    toggleEditorMode(mode) {
      this.controller.toggleEditorMode(mode);
    },
    changeHistoryStep(type) {
      this.controller.changeHistoryStep(type);
    },
    clearEditingState() {
      this.controller.clearEditingState();
    },
    saveData() {
      this.controller.saveData();
    }
  }
};
</script>

<style lang="scss">
.pt-editor {
  display: flex;
  flex-direction: column;
  flex: 1;

  &-container {
    padding: 16px;
    flex: 1;
  }

  .map-editor-mode {
    margin-top: 0;
  }
}
</style>
